import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'personAgendaBlock.title',
    defaultMessage: 'Appointments calendar',
  },
  presentationConfig: {
    id: 'personAgendaBlock.presentationConfig',
    defaultMessage: 'Presentation',
  },
  initialView: {
    id: 'personAgendaBlock.initialView',
    defaultMessage: 'Initial view',
  },
  monthView: {
    id: 'personAgendaBlock.monthView',
    defaultMessage: 'Monthly calendar',
  },
  listView: {
    id: 'personAgendaBlock.listView',
    defaultMessage: 'Events list',
  },
  weekView: {
    id: 'personAgendaBlock.weekView',
    defaultMessage: 'Weekly calendar',
  },
  dayView: {
    id: 'personAgendaBlock.dayView',
    defaultMessage: 'Daily calendar',
  },
});

export const personAgendaSchema = ({ intl }) => ({
  title: intl.formatMessage(messages.title),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.presentationConfig),
      fields: ['initialView'],
    },
  ],
  properties: {
    initialView: {
      title: intl.formatMessage(messages.initialView),
      type: 'choice',
      choices: [
        ['month', intl.formatMessage(messages.monthView)],
        ['week', intl.formatMessage(messages.weekView)],
        ['day', intl.formatMessage(messages.dayView)],
        ['list', intl.formatMessage(messages.listView)],
      ],
      default: 'month',
    },
  },
  required: [],
});
